module.exports = __webpack_public_path__ + "img/head.f61b347f.png";